define('GoferParts.Documents.View', [
  'SCView',
  'gofer_parts_documents.tpl'
], function (
  SCViewModule,
  gofer_parts_documents_tpl
) {
  'use strict';

  var SCView = SCViewModule.SCView;

  function GoferPartsDocumentsDetailsView(options) {
    SCView.call(this, options);

    this.model = options.model;
    this.resources = options.resources || {};
    this.template = gofer_parts_documents_tpl;
  }

  GoferPartsDocumentsDetailsView.prototype = Object.create(SCView.prototype);
  GoferPartsDocumentsDetailsView.prototype.constructor = GoferPartsDocumentsDetailsView;

  GoferPartsDocumentsDetailsView.prototype.getContext = function () {
    return {
      resources: this.resources
    };
  };

  return GoferPartsDocumentsDetailsView;
});
